import { useState } from "react";
import Section from "../ui/Section";
import Button from "../ui/Button";
import WaitlistModal from "../ui/WaitlistModal";
import "./SchoolsInquiry.css";

export default function SchoolsInquiry() {
  const [open, setOpen] = useState(false);

  return (
    <Section tone="ink">
      <div className="schools-inquiry">
        <div>
          <h2 className="schools-inquiry__title">Eolass for schools</h2>
          <p className="schools-inquiry__body">
            Give every student in your class an adaptive course built from your own syllabus.
          </p>
        </div>
        <Button variant="onDark" size="lg" onClick={() => setOpen(true)}>
          Get in touch
        </Button>
      </div>

      <WaitlistModal open={open} onClose={() => setOpen(false)} />
    </Section>
  );
}
